export default async callbacks => {
  return Object.values(await Promise.allSettled(callbacks))
    .map(({ status, value, reason }) => ({
      ok: status === 'fulfilled',
      data: value?.data,
    }));
}
